import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routesP = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/pc/index.vue')
  },
  {
    path: '/indexData',
    name: 'indexData',
    component: () => import('@/views/pc/indexData.vue')
  },
  {
    path: '/indexDataDetail',
    name: 'indexDataDetail',
    component: () => import('@/views/pc/detail/indexDataDetail.vue')
  },
  {
    path: '/teachingProject',
    name: 'teachingProject',
    component: () => import('@/views/pc/teachingProject.vue')
  },
  {
    path: '/applyfor',
    name: 'applyfor',
    component: () => import('@/views/pc/applyfor.vue')
  },
  {
    path: '/applyGuide',
    name: 'applyGuide',
    component: () => import('@/views/pc/applyGuide.vue')
  },
  {
    path: '/facultyTeam',
    name: 'facultyTeam',
    component: () => import('@/views/pc/facultyTeam.vue')
  },
  {
    path: '/research',
    name: 'research',
    component: () => import('@/views/pc/research.vue')
  },
  {
    path: '/facultyDetail',
    name: 'facultyDetail',
    component: () => import('@/views/pc/detail/facultyDetail.vue')
  },
  {
    path: '/student',
    name: 'student',
    component: () => import('@/views/pc/student.vue')
  },
  {
    path: '/studentDetail',
    name: 'studentDetail',
    component: () => import('@/views/pc/detail/studentDetail.vue')
  },
  {
    path: '/interaction',
    name: 'interaction',
    component: () => import('@/views/pc/interaction.vue')
  },
  {
    path: '/interactionDetail',
    name: 'interactionDetail',
    component: () => import('@/views/pc/detail/interactionDetail.vue')
  },
  {
    path: '/alumni',
    name: 'alumni',
    component: () => import('@/views/pc/alumni.vue')
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import('@/views/pc/cooperate.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/pc/aboutUs.vue')
  }
]
const routesM = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/mobile/index.vue')
  },
  {
    path: '/indexData',
    name: 'indexData',
    component: () => import('@/views/mobile/indexData.vue')
  },
  {
    path: '/indexDataDetail',
    name: 'indexDataDetail',
    component: () => import('@/views/mobile/detail/indexDataDetail.vue')
  },
  {
    path: '/teachingProject',
    name: 'teachingProject',
    component: () => import('@/views/mobile/teachingProject.vue')
  },
  {
    path: '/applyfor',
    name: 'applyfor',
    component: () => import('@/views/mobile/applyfor.vue')
  },
  {
    path: '/applyGuide',
    name: 'applyGuide',
    component: () => import('@/views/mobile/applyGuide.vue')
  },
  {
    path: '/facultyTeam',
    name: 'facultyTeam',
    component: () => import('@/views/mobile/facultyTeam.vue')
  },
  {
    path: '/research',
    name: 'research',
    component: () => import('@/views/mobile/research.vue')
  },
  {
    path: '/facultyDetail',
    name: 'facultyDetail',
    component: () => import('@/views/mobile/detail/facultyDetail.vue')
  },
  {
    path: '/student',
    name: 'student',
    component: () => import('@/views/mobile/student.vue')
  },
  {
    path: '/studentDetail',
    name: 'studentDetail',
    component: () => import('@/views/mobile/detail/studentDetail.vue')
  },
  {
    path: '/interaction',
    name: 'interaction',
    component: () => import('@/views/mobile/interaction.vue')
  },
  {
    path: '/interactionDetail',
    name: 'interactionDetail',
    component: () => import('@/views/mobile/detail/interactionDetail.vue')
  },
  {
    path: '/alumni',
    name: 'alumni',
    component: () => import('@/views/mobile/alumni.vue')
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import('@/views/mobile/cooperate.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/mobile/aboutUs.vue')
  }
]
var routes = []
const screenWidth = window.innerWidth
console.log(screenWidth)
// 移动端引入公共样式
if (screenWidth <= 750) {
  routes = routesM// 手机端独立
} else {
  routes = routesP
}

const router = new Router({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js